import { merge } from '@/helpers/Utility';
import React from 'react';
import { withField } from './withField';

interface InjectedProps {
  value: number;
  onChange: (newValue: number) => void;
}

interface Props {
  className?: string;
}

export const NumberInput = React.forwardRef<HTMLInputElement, Props & InjectedProps>(
  ({ value, onChange, className }, ref) => {
    const handleChange = (val: string) => {
      // allow empty or "-"
      if (/^\-?[0-9]*$/.test(val)) {
        onChange(val === '' || val === '-' ? 0 : parseInt(val, 10));
      }
    };

    return (
      <input
        ref={ref}
        className={merge(
          'focus:ring-primary-500 bg-primary-std focus:border-primary-500 flex-1 min-w-0 block w-full sm:text-sm border-primary-std',
          className
        )}
        value={value?.toString() ?? ''}
        onChange={e => handleChange(e.target.value)}
        type="text"
      />
    );
  }
);

export const NumberField = withField<number, object>(NumberInput);
